import React, { useState } from "react";
import { useAuth } from "../../context/Auth";
import { toast } from "react-toastify";
import { AiOutlineClose } from "react-icons/ai";
import { showApiErrors } from "../../utils/errorHandler";

const CreatePositionModal = ({
  setShowCreatePositionModal,
  fetchExecutivePositions,
  groupId
}
) => {
  const { requestWithAuth } = useAuth();
  // Form state for creating position
  const [positionForm, setPositionForm] = useState({
    position: "",
    description: "",
  });

  const handleCreatePosition = async (e) => {
    e.preventDefault();
    try {
      const response = await requestWithAuth(
        `/groups/group-positions/${groupId}/`,
        "POST",
        positionForm
      );

      toast.success("Position created successfully!");
      setShowCreatePositionModal(false);
      setPositionForm({ name: "", description: "" });
      fetchExecutivePositions();
    } catch (error) {
      showApiErrors(error)
    }
  };
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-lg font-semibold text-gray-900">
              Create Executive Position
            </h3>
            <button
              onClick={() => setShowCreatePositionModal(false)}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <AiOutlineClose className="text-xl text-gray-600" />
            </button>
          </div>

          <form onSubmit={handleCreatePosition} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Position Name *
              </label>
              <input
                type="text"
                value={positionForm.position}
                onChange={(e) =>
                  setPositionForm((prev) => ({ ...prev, position: e.target.value }))
                }
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                required
                placeholder="e.g., President, Secretary, Treasurer"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Description
              </label>
              <textarea
                value={positionForm.description}
                onChange={(e) =>
                  setPositionForm((prev) => ({
                    ...prev,
                    description: e.target.value,
                  }))
                }
                rows={3}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
                placeholder="Brief description of the position..."
              />
            </div>

            <div className="flex gap-3 pt-4">
              <button
                type="button"
                onClick={() => setShowCreatePositionModal(false)}
                className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
              >
                Create Position
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreatePositionModal;
